import { Component, HostBinding, Inject } from '@angular/core';
import {
  MatLegacySnackBarRef as MatSnackBarRef,
  MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA,
} from '@angular/material/legacy-snack-bar';
import { PopupNotificationData } from '../public-api';

@Component({
  selector: 'studio-popup-notification',
  templateUrl: './popup-notification.component.html',
  styleUrls: ['./popup-notification.component.scss'],
})
export class PopupNotificationComponent {
  @HostBinding('class') get classes() {
    return `${this.data.theme} ${this.data.type}`;
  }

  constructor(
    public snackBarRef: MatSnackBarRef<PopupNotificationComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: PopupNotificationData,
  ) {}

  public dismiss() {
    this.snackBarRef.dismiss();
  }
}
